import AutomationBuilder from "./builder/AutomationBuilder";
import AutomationFilter from "./modals/automation-filter";
import SaveAsTemplate from "./modals/save-as-template";
import TurnOffAutomation from "./modals/turn-off-automation";
import TurnOnAutomation from "./modals/turn-on-automation";

const LIST_URL = "/coaching-portal/custom-workflows/";

// The screen where one Email Automation is built: its flow and the panel of the step being edited
const AutomationBuilderController = async ({ res, req, locals, load }) => {
  const { query = {} } = req;
  const modal = query.modal || {};

  await load("automationDetail", req.params.id);
  // Not found, or the account does not have Email Automations
  if (!locals.automationDetail) return res.redirect(LIST_URL);

  const { automation } = locals.automationDetail;
  await load("automationTriggers", automation.product);
  await load("sendingSettings");
  await load("automationFilterOptions");
  if (query.tab === "activity") {
    const { person } = query;
    const params = Object.fromEntries(
      ["status", "search", "sort", "dir", "page"]
        .filter((key) => query[key])
        .map((key) => [key, query[key]])
    );
    await load("automationActivity", { id: automation._id, ...params });
    if (person) {
      await load("automationJourney", {
        id: automation._id,
        enrollmentId: person,
      });
    }
  }

  if (modal.type === "turnOnAutomation") {
    await load("automationBackfill", automation._id);
  }
  if (modal.type === "saveAsTemplate") {
    await load("automationTemplates", automation.product);
  }

  const definition = locals.automationTriggers?.triggers.find(
    (trigger) => trigger.key === automation.trigger.key
  );
  if (!definition) return res.redirect(LIST_URL);

  locals.modal = {
    automationFilter: (
      <AutomationFilter
        detail={locals.automationDetail}
        definition={definition}
        options={locals.automationFilterOptions ?? undefined}
        target={query.target || "trigger"}
      />
    ),
    turnOnAutomation: (
      <TurnOnAutomation
        detail={locals.automationDetail}
        backfill={locals.automationBackfill ?? undefined}
        definition={definition}
        options={locals.automationFilterOptions ?? undefined}
        returnTo={`/coaching-portal/custom-workflows/automations/${automation._id}`}
      />
    ),
    turnOffAutomation: (
      <TurnOffAutomation
        detail={locals.automationDetail}
        returnTo={`/coaching-portal/custom-workflows/automations/${automation._id}`}
      />
    ),
    saveAsTemplate: (
      <SaveAsTemplate
        detail={locals.automationDetail}
        teamName={locals.automationTemplates?.teamName ?? ""}
        returnTo={`/coaching-portal/custom-workflows/automations/${automation._id}`}
      />
    ),
  }[modal.type];

  res.body = <AutomationBuilder />;
};

export default AutomationBuilderController;
